import { IHttpService } from "../HttpService";
import User, { IUser } from "../../model/user/User";

export interface IUserService {
  getUserProfile(): Promise<IUser>;
}

const UserService = (httpService): IUserService => {
  const _http: IHttpService = httpService;
  const _baseUrl: string = "/api";
  const _usersPath: string = "users";

  return {
    async getUserProfile() {
      const path = _http.buildPath(_baseUrl, _usersPath, "me");
      const response = await _http.get(path);
      const responseJSON = await _http.toJSON(response);

      return User(responseJSON);
    }
  };
};

export default UserService;
